/** Usuario Calidad con acceso operativo a Asistencia alumnos (fuera del menú estándar de puesto). */
export const IDERPS_ASISTENCIA_ALUMNOS = [3211]

/** Columna Comentarios calidad en Asistencia alumnos. */
export const IDERPS_COMENTARIOS_CALIDAD = [3211, 334, 568, 1]

function menuTienePath(menu, path) {
  if (!Array.isArray(menu)) return false
  for (const top of menu) {
    for (const cat of top.items || []) {
      if (cat && cat.path === path) return true
      for (const child of cat.items || []) {
        if (child && child.path === path) return true
      }
    }
  }
  return false
}

/** Inyecta Asistencia alumnos en el menú Operaciones → Alumnos para iderp 3211. */
export function asegurarMenuAsistenciaAlumnos(menu, iderp) {
  if (!IDERPS_ASISTENCIA_ALUMNOS.includes(Number(iderp))) {
    return Array.isArray(menu) ? menu : []
  }

  const list = Array.isArray(menu) ? menu.slice() : []
  if (menuTienePath(list, 'AsistenciaAlumnos')) return list

  let target = list.find(function (m) {
    return Number(m.idmenu) === 5
  })
  if (!target) {
    target = { title: 'Operaciones', idmenu: 5, path: null, items: [] }
    list.push(target)
  }
  if (!Array.isArray(target.items)) target.items = []

  let alumnos = target.items.find(function (cat) {
    return cat && (cat.title === 'Alumnos' || Number(cat.idsubmenu) === 10)
  })
  if (!alumnos) {
    alumnos = { title: 'Alumnos', idsubmenu: 10, items: [] }
    target.items.push(alumnos)
  }
  if (!Array.isArray(alumnos.items)) alumnos.items = []

  if (!menuTienePath(list, 'AsistenciaAlumnos')) {
    alumnos.items.push({
      title: 'Asistencia alumnos',
      path: 'AsistenciaAlumnos',
      icon: 'mdi-clipboard-list-outline',
      active: 1,
    })
  }

  return list
}

export function puedeVerComentariosCalidad(iderp) {
  return IDERPS_COMENTARIOS_CALIDAD.includes(Number(iderp))
}

/** Columna Zoom en Asistencia alumnos: Jefe de TI (11) y Desarrollador de software (12). */
export const PUESTOS_COLUMNA_ZOOM = [11, 12]

export function puedeVerColumnaZoom(idpuesto) {
  return PUESTOS_COLUMNA_ZOOM.indexOf(Number(idpuesto)) !== -1
}

/** Capa Zoom de prueba: grupo LMS 24468 / salón 258. */
export const GRUPO_LMS_PRUEBA_ZOOM = 24468

export function esFilaCapaZoom(item) {
  return Number(item && item.id_grupo_lms) === GRUPO_LMS_PRUEBA_ZOOM
}

export function tieneAccesoAsistenciaAlumnos(iderp) {
  return IDERPS_ASISTENCIA_ALUMNOS.includes(Number(iderp))
}
